/**
 * Created by Administrator on 2017/7/2.
 */
export const LOADBLOG = 'LoadBlog';
export const SHOWBLOG = 'ShowBlog';


// WEBPACK FOOTER //
// ./src/Component/BlogContent/actionTypes.js